export const OPEN_MENU_ITEM = 'mainMenu/OPEN_MENU_ITEM';
export const CLOSE_MENU_ITEM = 'mainMenu/CLOSE_MENU_ITEM';
export const RETRACT_MENU = 'mainMenu/RETRACT_MENU';
